<template>
  <div class="main-container">
    <app-number-keyboard :enterFunction="searchPatient" :title="getMessage('MSG_INGRESA_NUMERO_DOCUMENTO')"></app-number-keyboard>
    <app-back-home :compFrom="'patientSearch'"></app-back-home>
    <app-loader></app-loader>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import BackHome from '@/components/AutoRecepcion/BackHome'
import NumberKeyboard from '@/components/AutoRecepcion/NumberKeyboard'
import Loader from '@/components/AutoRecepcion/Loader'

export default {
  components: {
    'app-loader': Loader,
    'app-back-home': BackHome,
    'app-number-keyboard': NumberKeyboard
  },
  data () {
    return {
      showModal: true,
      instanceIdle: null
    }
  },
  computed: {
    ...mapGetters('Appointment', ['appointments']),
    ...mapGetters('Patient', ['patients']),
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  methods: {
    ...mapActions('Patient', ['setPatient', 'fetchPatientsByNroDoc']),
    ...mapActions('Appointment', ['fetchAppointmentsByDoc']),
    NoPatientFound (document) {
      this.$router.push({
        name: 'patientAppointmentNotFound',
        params: {
          message: this.getMessage('MSG_PACIENTE_NO_EXISTE'),
          data: document
        }
      })
    },
    searchPatient (document) {
      var vm = this
      if (document.length < 6) return
      this.fetchPatientsByNroDoc(document).then(() => {
        if (vm.patients.length === 1) {
          vm.selectPatient(vm.patients[0])
        } else if (vm.patients.length > 1) {
          vm.$router.push({
            name: 'patientSelector',
            params: { selectPatient: vm.selectPatient }
          })
        } else if (vm.patients.length === 0) {
          vm.searchPatientWithoutRecord(document)
        }
      })
    },
    searchPatientWithoutRecord (document) {
      var vm = this
      vm.fetchAppointmentsByDoc(document).then(() => {
        if (vm.patients.length === 1) {
          vm.selectPatient(vm.patients[0])
        } else if (vm.patients.length > 1) {
          vm.$router.push({
            name: 'patientSelector',
            params: { selectPatient: vm.selectPatient }
          })
        } else if (vm.patients.length === 0) {
          vm.NoPatientFound(document)
        }
      })
    },
    selectPatient (patient) {
      this.setPatient(patient)
      this.$router.push({
        name: 'appointmentSelector'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
